export default "__VITE_ASSET__Bh4afMTM__"